var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"CharacterPanels",attrs:{"name":"list-complete","tag":"div"}},_vm._l((_vm.characters),function(ref){
var key = ref.key;
return (_vm.get(key) && _vm.getMessage(key))?_c('div',{key:key,staticClass:"character"},[_c('figure',{staticClass:"image",style:({
      backgroundImage: _vm.url(_vm.get(key).imageKey)
    })}),_c('p',{staticClass:"balloon",domProps:{"textContent":_vm._s(_vm.getMessage(key).text)}})]):_vm._e()}))}
var staticRenderFns = []

export { render, staticRenderFns }